import { render } from "./focus.vue?vue&type=template&id=0084e306&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"

import "./focus.vue?vue&type=style&index=0&id=0084e306&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0084e306"]])

export default __exports__